import { useState } from "react"
import { useNavigate } from "react-router"
import { toast } from "react-toastify"
import Server from "../../Shared/Server"
import Spinner from "../../Shared/Spinner"
import {InputField, NullableInput} from "../../Shared/InputField"
import AsyncSelectField from "../../Shared/AsyncSelect"

const CollectorTransferForm = (props) => {
    const [errors, setErrors] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [faccountOptions, setFAccountOptions] = useState([])
    const [taccountOptions, setTAccountOptions] = useState([])

    const [formData, setFormData] = useState({
        amount: "",
        date: new Date().toISOString().slice(0, 10),
        remark: "",
        faccount_id: "",
        taccount_id: "",
    })
    const {faccount_id, taccount_id, amount, remark, date} = formData

    const navigate = useNavigate()

    const loadOptions = async (url, query, setOptions) => {
        try {
            const params = { q: query };

            const response = await Server.get(`/options/${url}`, { params });
            setOptions(response.data);
            return response.data;
        } catch (error) {
            return [];
        }
    };

    const onChange = (e) => {
        setFormData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value
        }))
    }

    const onSubmit = (e) => {
        e.preventDefault()

        const payload = {faccount_id, taccount_id, amount, remark, date}
        addTransaction(payload)
    }
    
    // add account
    const addTransaction = async (payload) => {
        setIsLoading(true)
        try {
            const response = await Server.post('/collector-accounts/collector-cash-transfer', payload)
                toast.success(response.data?.detail)
                setFormData(() => ({
                    faccount_id: "",
                    taccount_id: taccount_id,
                    amount: "",
                    remark: "",
                    date: date,
                }))
                setIsLoading(false)
                navigate('/collector-cash-transfer')
        } catch (error) {
            setIsLoading(false)
            if(error.response.status === 401){
                navigate('/login')
            }else if (error.response.status === 422){
                setErrors({})
                error.response?.data?.detail.map((err) => (
                    setErrors((prevState) => ({
                        ...prevState,
                        [err.loc[1]]: err.msg
                    }))
                ))
            }else if (error.response.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else {
                toast.error(error.response.data.detail);
            }
        }
    }

    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
        <div className="card">
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">Cash Transfer Form</h3>
            </div>
            <div className="card-body">
            <form onSubmit={onSubmit}>
                    <div className="row">
                        <div className="col-md-4">
                            <AsyncSelectField
                                name="faccount_id"
                                label="From Account"
                                value={faccount_id}
                                onChange={onChange}
                                loadOptions={(query) => loadOptions('collector-account-balance', query, setFAccountOptions)}
                                options={faccountOptions}
                                placeholder="Start typing to search..."
                                error={errors.faccount_id}
                            />
                        </div>
                        <div className="col-md-4">
                            <AsyncSelectField
                                name="taccount_id"
                                label="To Account"
                                value={taccount_id}
                                onChange={onChange}
                                loadOptions={(query) => loadOptions('saving-accounts', query, setTAccountOptions)}
                                options={taccountOptions}
                                placeholder="Start typing to search..."
                                error={errors.taccount_id}
                            />
                        </div>
                        <div className="col-md-4">
                            <InputField
                                name="date"
                                type="date"
                                label="Date"
                                value={date}
                                onChange={onChange}
                                error={errors.date}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <InputField
                                placeholder="Transfering Amount"
                                name="amount"
                                type="number"
                                label="Amount"
                                value={amount}
                                onChange={onChange}
                                error={errors.amount}
                            />
                        </div>
                        <div className="col-md-8">
                            <NullableInput
                                placeholder="Remark (Optional)"
                                name="remark"
                                type="text"
                                label="Remark"
                                value={remark}
                                onChange={onChange}
                                error={errors.remark}
                            />
                        </div>
                    </div>
                    <br/>
                    <div className="row">
                        <div className="col-md-12">
                            <input type="submit" className="btn btn-outline-info" value="Transfer" style={{float: 'right'}}/>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <br/>
    </>
  )
}

export default CollectorTransferForm
